module.exports = __webpack_public_path__ + "static/mh-task1-478982ef45f32620b383fbaf251e8de3.jpeg";